import React, { memo } from 'react';
import { IconProps } from './iconInterfaces';

export const AccessTimeIcon = memo(({
    width = 18,
    height = 18,
    symbolFillColor = '#808080',
    svgTitle
}: IconProps) =>
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' role='img'>
        {svgTitle ? <title>{svgTitle}</title> : null}
        <path d='M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11.78 7H11.72C11.32 7 11 7.32 11 7.72V12.44C11 12.79 11.18 13.12 11.49 13.3L15.64 15.79C15.98 15.99 16.42 15.89 16.62 15.55C16.83 15.21 16.72 14.76 16.37 14.56L12.5 12.26V7.72C12.5 7.32 12.18 7 11.78 7V7Z' fill={symbolFillColor}/>
    </svg>
);

AccessTimeIcon.displayName = 'AccessTimeIcon';